import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { aboutNewImg2 } from "../../Constant";

function SafetyWork() {
    return (
        <>
            <Header />
            <section
                className="servcies py-10"
                style={{ backgroundImage: `url(${aboutNewImg2})` }}
            >
                <div className="container hero supplement ">
                    <div className="row">
                        <div className="col-md-6 py-10">
                            <h1 className="white">Satey At Work</h1>
                            <p className="white">
                                We are committed to providing you with a safe
                                and healthy environment for your growth and
                                development.
                            </p>
                        </div>
                        <div className="col-md-6"></div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container" style={{ padding: "40px;" }}>
                    <div className="row ">
                        <div className="col-md-12">
                            <div className="contact-box border-right">
                                <h4>Workplace Safety and Health</h4>
                                <p>
                                    Three U.S. Department of Labor (DOL)
                                    agencies have responsibility for the
                                    administration and enforcement of the laws
                                    enacted to protect the safety and health of
                                    workers in America.
                                </p>
                            </div>
                            <div className="contact-box border-right">
                                <h4>Fair Labor Standards Act</h4>
                                <p>
                                    Administers four major disability
                                    compensation programs which provide wage
                                    replacement benefits, medical treatment,
                                    vocational rehabilitation and other benefits
                                    to certain workers or their dependents who
                                    experience work-related injury or
                                    occupational disease. You can also read more
                                    at our workers'
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default SafetyWork;
